import React from 'react';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import StyledNavLink from './StyledNavLink';

const NavLink = ({label = null, url = null, outsideNavigation = false, icon = null, ...rest}) => {
	const history = useHistory();
	const props = {
		...rest,
		type: 'button',
		variant: 'ghost',
		size: 'small'
	};

	if (label) props.title = label;
	if (icon) props.svg = icon;
	if (url)
		props.onClick = () => {
			if (outsideNavigation) window.open(url, '_blank');
			else history.push(url);
		};

	return <StyledNavLink {...props} />;
};

NavLink.propTypes = {
	label: PropTypes.string,
	url: PropTypes.string,
	outsideNavigation: PropTypes.bool
};

export default NavLink;
